import { Component } from "react";
import PropTypes from "prop-types";
import { v4 as uuidv4 } from "uuid";

class ColorPaletteDetails extends Component {
  constructor(props) {
    super(props);
    this.state = { ...props.palette };
  }

  /**
   * Enter edit mode for the palette details.
   * @param {Event} e DOM event
   */
  editPaletteDetails(e) {
    e.preventDefault();
    this.setState({ editDetails: true });
  }

  /**
   * Placeholder for save palette action (prevent default submit behavior).
   * @param {Event} e DOM event
   */
  onSavePalette(e) {
    e.preventDefault();
  }

  /**
   * Save edited palette details back to parent via `onSave` prop.
   * @param {Event} e DOM event from form submit
   */
  onSavePaletteDetails(e) {
    e.preventDefault();
    this.setState(
      {
        paletteDetails: { paletteName: e.target.elements["paletteName"].value },
        editDetails: false,
      },
      () => this.props.onSave(this.state),
    );
  }

  /**
   * Clone the current palette by generating a new id and saving.
   */
  onClonePalette() {
    const newPalette = { ...this.state };
    newPalette.id = uuidv4();
    newPalette.paletteDetails.paletteName =
      newPalette.paletteDetails.paletteName + " (clone)";

    this.props.onSave(newPalette);
  }

  /**
   * Trigger deletion of the current palette via `onDelete` prop.
   */
  onDeletePalette() {
    this.props.onDelete(this.state.id);
  }

  render() {
    return (
      <div className="color-palette-details">
        <div className="row">
          <div className="col-xs-12">
            <div>
              <button size="xs" onClick={(e) => this.editPaletteDetails(e)}>
                Edit Palette Details
              </button>
              <button onClick={(e) => this.onClonePalette(e)} size="xs">
                Clone Palette
              </button>
              <button
                onClick={(e) => this.onDeletePalette(e)}
                size="xs"
                negative="true"
              >
                Delete Palette
              </button>
            </div>
          </div>
          <div className="col-xs-12 col-md-6">
            {this.state.editDetails && (
              <div className="my-3">
                <form onSubmit={(e) => this.onSavePaletteDetails(e)}>
                  <label htmlFor="paletteName">Palette Name</label>
                  <input
                    type="text"
                    name="paletteName"
                    id="paletteName"
                    defaultValue={this.state.paletteDetails.paletteName}
                    label="Palette Name"
                  />
                  <div className="my-3">
                    <button
                      type="button"
                      onClick={(e) => this.setState({ editDetails: false })}
                    >
                      Cancel
                    </button>
                    <button type="submit">Save</button>
                  </div>
                </form>
              </div>
            )}
            {!this.state.editDetails && (
              <h1>{this.state.paletteDetails.paletteName}</h1>
            )}
          </div>
        </div>
      </div>
    );
  }
}

ColorPaletteDetails.propTypes = {
  paletteName: PropTypes.string,
  onPaletteDetailChange: PropTypes.func,
};

ColorPaletteDetails.defaultProps = {
  onPaletteDetailChange: () => {},
};

export default ColorPaletteDetails;
